import { getData, postData, patchData, deleteData } from '../utils/api';

// Get all categories with pagination and filters
export const getCategories = async (params = {}) => {
  const {
    page = 1,
    limit = 10,
    sortField = 'displayOrder',
    sortValue = 'ASC',
    isActive = '',
    searchKey = ''
  } = params;

  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sortField,
    sortValue,
    ...(isActive && { isActive }),
    ...(searchKey && { searchKey })
  });

  return getData(`/data/category?${queryParams.toString()}`);
};

// Get single category by ID or slug
export const getCategoryById = async (id) => {
  return getData(`/data/category/${id}`);
};

// Create a new category
export const createCategory = async (categoryData) => {
  const { name, description, isActive = true, displayOrder = 0 } = categoryData;
  
  const requestData = {
    name,
    description,
    isActive,
    displayOrder
  };
  
  return postData('/data/category', requestData);
};

// Update an existing category
export const updateCategory = async (categoryData) => {
  const { categoryId, name, description, isActive, displayOrder } = categoryData;
  
  const updateData = { categoryId };
  
  if (name !== undefined) updateData.name = name;
  if (description !== undefined) updateData.description = description;
  if (isActive !== undefined) updateData.isActive = isActive;
  if (displayOrder !== undefined) updateData.displayOrder = displayOrder;

  return patchData('/data/category', updateData);
};

// Delete a category
export const deleteCategory = async (categoryId) => {
  return deleteData('/data/category', {
    data: { categoryId }
  });
};

export default {
  getCategories,
  getCategoryById,
  createCategory,
  updateCategory,
  deleteCategory
};

